import { IServiceParameter, ServiceMeterTypeEnum } from "@monorepo/types";

export const modifyToValues = ({ values, counters }: { values: any; counters: Array<IServiceParameter> }) => {
  const unhiddenToFromCounters = counters.filter(
    (c) =>
      c.group_label &&
      !c.hidden &&
      (c.meter_type === ServiceMeterTypeEnum.TO || c.meter_type === ServiceMeterTypeEnum.FROM)
  );
  let updatedValues = { ...values };
  Object.keys(updatedValues)?.forEach((key) => {
    if (
      unhiddenToFromCounters.find((c) => c.meter_type === ServiceMeterTypeEnum.TO && c.parameter_name === key) &&
      (!updatedValues[key] || updatedValues[key] === "0" || updatedValues[key] === "-")
    ) {
      const fromCounterValue =
        updatedValues[
          unhiddenToFromCounters[unhiddenToFromCounters.findIndex((c) => c.parameter_name === key) - 1]?.parameter_name
        ];
      if (fromCounterValue) {
        //if no value exists in TO counter param, setting it to the same as FROM
        updatedValues[key] = fromCounterValue;
      }
    }
  });

  return updatedValues;
};
